import { ReactComponent as EmojiVeryBadIcon } from "assets/icons/emoji-very-bad.svg"
import { ReactComponent as EmojiBadIcon } from "assets/icons/emoji-bad.svg"
import { ReactComponent as EmojiNeutralIcon } from "assets/icons/emoji-neutral.svg"
import { ReactComponent as EmojiGoodIcon } from "assets/icons/emoji-good.svg"
import { ReactComponent as EmojiVeryGoodIcon } from "assets/icons/emoji-very-good.svg"
import styles from "./styles.module.scss"
interface IRatingEmoji {
  fontSize: number
  rating?: "very bad" | "bad" | "neutral" | "good" | "very good"
}

const RatingEmoji: React.FC<IRatingEmoji> = ({
  rating = "neutral",
  ...props
}) => {
  switch (rating) {
    case "very bad":
      return <EmojiVeryBadIcon className={styles.very_bad} {...props} />

    case "bad":
      return <EmojiBadIcon className={styles.bad} {...props} />

    case "neutral":
      return <EmojiNeutralIcon className={styles.neutral} {...props} />

    case "good":
      return <EmojiGoodIcon className={styles.good} {...props} />
    case "very good":
      return <EmojiVeryGoodIcon className={styles.very_good} {...props} />
    default:
      return <EmojiNeutralIcon className={styles.neutral} {...props} />
  }
}

export default RatingEmoji
